import { registerNotification } from './registry'

registerNotification('module:enter', {
  color: (_, theme) => theme.semantic.positive,
  icon:  notification => notification.info.moduleType === 'calendar' ? 'calendar' : 'puzzle',
})